// extracted by mini-css-extract-plugin
export default {"root":"toggleable_text___root___e516b22b","more":"toggleable_text___more___ab805622","sameLine":"toggleable_text___sameLine___ab1c0ddc"};